import createFields from './createFields';
import plain from './structure/plain';

export default createFields(plain);


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/redux-form/es/Fields.js
// module id = 1195
// module chunks = 4